

export const GETLENGTH_SUCCESS = "GETLENGTH_SUCCESS";
export const GETLENGTH_ERROR = "GETLENGTH_ERROR";

export const ADDLENGTH_SUCCESS = "ADDLENGTH_SUCCESS";
export const ADDLENGTH_ERROR = "ADDLENGTH_ERROR";

export const UPDATELENGTH_SUCCESS = "UPDATELENGTH_SUCCESS";
export const UPDATELENGTH_ERROR = "UPDATELENGTH_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";

export const LENGTH_WIDTH_SUCCESS = "LENGTH_WIDTH_SUCCESS";
export const LENGTH_WIDTH_ERROR = "LENGTH_WIDTH_ERROR"


